import { Popover, Table, Tooltip } from 'antd'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { ExclamationCircleFilled, InfoCircleOutlined } from '@ant-design/icons'
import { isDefined } from '@/utils/general'

type FreightRenderProps = {
  supplyOption: Gravitate.SupplyOption
  formattedCurrency: string
  formattedDistance: string
}

export function FreightRender({ supplyOption, formattedCurrency, formattedDistance }: FreightRenderProps) {
  const showPopover = supplyOption.legs && supplyOption.legs.length > 0 && !supplyOption.freight_undefined
  return (
    <Popover
      placement='topRight'
      content={
        <PopoverContent supplyOption={supplyOption} formattedDistance={formattedDistance} showPopover={showPopover} />
      }
      trigger='hover'
    >
      <Tooltip title={!!supplyOption.freight_undefined && 'No freight rate defined'}>
        <div>
          <Texto weight={'bold'} appearance={supplyOption.freight_undefined ? 'error' : 'default'}>
            {!!supplyOption.freight_undefined && <ExclamationCircleFilled className='pr-1' />}
            {formattedCurrency}
            {supplyOption?.freight.toFixed(5)}
            {showPopover && (
              <span style={{ color: 'var(--gray-500)', fontSize: '12px' }}>
                <InfoCircleOutlined className='pl-2' />
              </span>
            )}
          </Texto>
        </div>
      </Tooltip>
    </Popover>
  )
}

type PopoverContentProps = {
  supplyOption: Gravitate.SupplyOption
  formattedDistance: string
  showPopover: boolean
}

function PopoverContent({ supplyOption, formattedDistance, showPopover }: PopoverContentProps) {
  if (!showPopover) return null

  const data = supplyOption.legs
  return (
    <Vertical>
      <Table size='small' dataSource={data} columns={freightRendererColumns(formattedDistance)} pagination={false} />
      <Horizontal gap={12} justifyContent='flex-end' className='mt-3' style={{ paddingRight: '8px' }}>
        <Texto weight={'bold'}>Freight Distance</Texto>
        <Texto weight={'bold'}>{supplyOption.freight_distance}</Texto>
      </Horizontal>
    </Vertical>
  )
}

const freightRendererColumns = (formattedDistance: string) => [
  {
    title: 'Origin',
    dataIndex: 'origin',
    key: 'origin',
  },
  {
    title: 'Destination',
    dataIndex: 'destination',
    align: 'right' as const,
    key: 'destination',
  },
  {
    title: `Distance (${formattedDistance})`,
    dataIndex: 'distance',
    key: 'distance',
    align: 'right' as const,
    render: (value: number) => value.toFixed(2),
  },
]
